import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../global/commonStyle';

interface Prop {
  isSent?: boolean;
  isDeleteUserPage?: boolean;
  isForgotPasswordPage?: boolean;
  isForgotPasswordSent?: boolean;
  isLoginPage?: boolean;
  isResetPasswordPage?: boolean;
  isSignupPage?: boolean;
}

const Group = styled.div<Prop>`
  width: 100%;
  height: 100dvh;
  overflow: auto;
  margin: auto;
  background-color: var(--background-secondary);
  ${FlexCenter}

  ${(Props: Prop) =>
    Props.isDeleteUserPage &&
    css`
      ${mobile_xl(css`
        min-height: 382px;
      `)}
    `}
  ${(Props: Prop) =>
    Props.isForgotPasswordPage &&
    css`
      ${mobile_xl(css`
        min-height: 384px;
      `)}
    `}
     ${(Props: Prop) =>
    (Props.isLoginPage || Props.isResetPasswordPage) &&
    css`
      ${mobile_xl(css`
        min-height: 465px;
      `)}
    `}
      ${(Props: Prop) =>
    Props.isSignupPage &&
    css`
      ${mobile_xl(css`
        min-height: 556px;
      `)}
    `}
`;
const Content = styled.div<Prop>`
  width: 100%;
  max-width: 300px;
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-32);
  background-color: var(--background-secondary);
  ${(Props: Prop) =>
    Props.isSent &&
    css`
      width: 100%;
      max-width: 100%;
      justify-content: center;
    `}

  ${mobile_xl(css`
    max-width: 100%;
    padding-inline: var(--space-16);
  `)}
  ${(Props: Prop) =>
    Props.isLoginPage &&
    css`
      gap: var(--space-80);
      align-items: unset;
      ${mobile_xl(css`
        gap: var(--space-32);
      `)}
    `}
  ${(Props: Prop) =>
    Props.isSignupPage &&
    css`
      /* max-width: 582px; */
      ${mobile_xl(css`
        max-width: 100%;
        gap: var(--space-32);
      `)}
    `}
`;

const Icon = styled.div`
  ${FlexCenter}
  ${mobile_xl(css`
    .svgIcon {
      width: 40px;
      height: 40px;
    }
  `)}
`;
const Title = styled.h1`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: var(--space-0);
  text-align: center;
  ${mobile_xl(css`
    align-items: center;
  `)}
`;
const Form = styled.form<Prop>`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: var(--space-24);
  ${mobile_xl(css<Prop>`
    gap: ${({ isLoginPage, isSignupPage }) => (isSignupPage || isLoginPage ? 'var(--space-24)' : 'var(--space-32)')};
  `)}
  ${(Props: Prop) =>
    Props.isLoginPage &&
    css`
      flex-direction: column;
    `}
`;
const FormBlock = styled.div`
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  ${mobile_xl(css`
    max-width: 100%;
  `)}
`;
const InputValue = styled.input`
  ${Typography.body_lg}
  color: var(--text-primary);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  padding: var(--space-13) var(--space-16);
  border-radius: var(--border-radius-8);
  outline: none;

  &:focus {
    border: 0.5px solid var(--brand-primary);
    z-index: var(--z-index-999);
  }
  ::placeholder {
    ${Typography.body_lg}
    color: var(--border-secondary);
  }
  ${(Props: Prop) =>
    (Props.isLoginPage || Props.isResetPasswordPage || Props.isSignupPage) &&
    css`
      border-radius: var(--border-radius-8) var(--border-radius-8) var(--border-radius-0) var(--border-radius-0);
      &.password {
        border-radius: var(--border-radius-0);
        margin-top: -1px;
      }
      &.password-input {
        border-radius: var(--border-radius-0) var(--border-radius-0) var(--border-radius-8) var(--border-radius-8);
        margin-top: -1px;
      }
    `}
`;

const FormTextArea = styled.div`
  display: flex;
  justify-content: center;
  gap: var(--space-4);
  ${(Props: Prop) =>
    Props.isResetPasswordPage &&
    css`
      gap: var(--space-6);
      margin-top: var(--space-48);
      ${mobile_xl(css`
        margin-top: var(--space-0);
      `)}
    `}
`;

const FormText = styled.p<Prop>`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  ${(Props: Prop) =>
    Props.isSent &&
    css`
      text-align: center;
      max-width: 560px;
      ${mobile_xl(css`
        margin-bottom: var(--space-10);
      `)}
    `}

  ${(Props: Prop) =>
    Props.isForgotPasswordSent &&
    css`
      text-align: center;
      ${mobile_xl(css`
        margin-bottom: var(--space-10);
      `)}
    `}
`;

const FormText1 = styled.p`
  ${Typography.body_md_medium}
  color: var(--brand-primary);
  margin: var(--space-0);
`;

const Viewer = styled.a`
  cursor: pointer;
  color: var(--brand-primary);
  text-decoration: none;
  ${Typography.body_md_medium}
  ${(Props: Prop) =>
    Props.isSignupPage &&
    css`
      color: var(--text-primary);
    `}
`;

const FormView = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-80);
  ${mobile_xl(css`
    gap: var(--space-32);
  `)}
`;

const ResetView = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
  ${mobile_xl(css`
    align-items: center;
  `)}
`;
const TopView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-32);
  width: 100%;
  max-width: 300px;
  ${mobile_xl(css`
    max-width: 100%;
  `)}
`;

const FormViewLogin = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: var(--space-20);
  ${mobile_xl(css`
    flex-direction: column;
    gap: var(--space-32);
    align-items: flex-end;
  `)}
`;

const FormTextPoint = styled.div`
  display: flex;
  justify-content: center;
  gap: var(--space-4);
  flex-wrap: wrap;
`;
const FormContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-20);
  .button-hover:hover {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-8);
    ${mobile_xl(css`
      background-color: unset;
    `)}
  }
  ${mobile_xl(css`
    width: 100%;
    gap: var(--space-16);
  `)}
`;
const TextLine = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  text-align: center;
`;

const FormSection = styled.div<Prop>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ isSignupPage }) => (isSignupPage ? 'var(--space-20)' : 'var(--space-12)')};
  ${mobile_xl(css<Prop>`
    gap: ${({ isSignupPage }) => (isSignupPage ? 'var(--space-32)' : 'var(--space-16)')};
  `)}
`;

// Divider with centered text (e.g., "or")
const DividerRow = styled.div`
  width: 100%;
  ${AlignCenter}
  gap: var(--space-12);
`;
const DividerLine = styled.div`
  flex: 1;
  height: 0.5px;
  background: var(--border-primary);
`;
const DividerText = styled.span`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;

export {
  Group,
  Content,
  Icon,
  Title,
  FormBlock,
  Form,
  InputValue,
  FormTextArea,
  FormText,
  Viewer,
  FormText1,
  FormView,
  ResetView,
  TopView,
  FormViewLogin,
  FormTextPoint,
  FormContent,
  TextLine,
  FormSection,
  DividerRow,
  DividerLine,
  DividerText
};
